/* eslint-disable no-undef */
export const envConfig = () => {
    const environment = process.env.NODE_ENV;
    const nodeEnv = process.env.REACT_APP_ENV;
    const devUrl = nodeEnv ? process.env.REACT_APP_SANDBOX_URL : "localhost";
    const devPort = nodeEnv ? process.env.REACT_APP_SANDBOX_PORT : "4200";

    // default prod config
    const config = {
        httpBaseUrl: "https://dpmapi.navajo-nsn.gov",
    };

    if (environment === "production" && nodeEnv === "sandbox") {
        // Sandbox Config after build
        config.httpBaseUrl = "http://" + devUrl + ":" + devPort + "/";
    } else if (environment === "development") {
        // Local after start
        config.httpBaseUrl = "http://" + devUrl + ":" + devPort + "/";
    }
    return config;
};
